module.exports = __webpack_public_path__ + "img/Isolation_Mode.d4761552.png";